import { c as _c } from "react/compiler-runtime";
import type { AdItem } from '@sbt-web/network/types';
import { getTransactionFlows, TransactionFlow } from '@/shared/tools/transaction/utils';
import { BuyNowButton } from './BuyNowButton';
import { SendOfferButton } from './SendOfferButton';
export interface AdBuyButtonsProps {
  onBuyNowButtonClick: () => void;
  onSendOfferButtonClick: () => void;
  item: AdItem;
  userId?: string;
  buyNowButtonClasses?: string[];
  sendOfferButtonClasses?: string[];
}
export const AdBuyButtons = t0 => {
  const $ = _c(16);
  const {
    onBuyNowButtonClick,
    onSendOfferButtonClick,
    item,
    userId,
    buyNowButtonClasses,
    sendOfferButtonClasses
  } = t0;
  let isBuyNowVisible;
  let t1;
  if ($[0] !== item || $[1] !== userId) {
    const transactionFlows = getTransactionFlows(item, userId);
    isBuyNowVisible = transactionFlows.includes(TransactionFlow.BuyNow);
    t1 = transactionFlows.includes(TransactionFlow.SendOffer);
    $[0] = item;
    $[1] = userId;
    $[2] = isBuyNowVisible;
    $[3] = t1;
  } else {
    isBuyNowVisible = $[2];
    t1 = $[3];
  }
  const isSendOfferVisible = t1;
  if (!isBuyNowVisible && !isSendOfferVisible) {
    return;
  }
  let t2;
  if ($[4] !== isBuyNowVisible || $[5] !== isSendOfferVisible || $[6] !== onSendOfferButtonClick || $[7] !== sendOfferButtonClasses) {
    t2 = isSendOfferVisible && <SendOfferButton onClick={onSendOfferButtonClick} isSecondary={isBuyNowVisible} classes={sendOfferButtonClasses} />;
    $[4] = isBuyNowVisible;
    $[5] = isSendOfferVisible;
    $[6] = onSendOfferButtonClick;
    $[7] = sendOfferButtonClasses;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== buyNowButtonClasses || $[10] !== isBuyNowVisible || $[11] !== onBuyNowButtonClick) {
    t3 = isBuyNowVisible && <BuyNowButton onClick={onBuyNowButtonClick} classes={buyNowButtonClasses} />;
    $[9] = buyNowButtonClasses;
    $[10] = isBuyNowVisible;
    $[11] = onBuyNowButtonClick;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  let t4;
  if ($[13] !== t2 || $[14] !== t3) {
    t4 = <>{t2}{t3}</>;
    $[13] = t2;
    $[14] = t3;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  return t4;
};